export const featureFlags = {
  DISABLE_HEADLESS_OFFERS_I18N_CACHE: 'disable-headless-offers-i18n-cache',
  DISABLE_BEST_BETS_WIDGET: 'disable-best-bets-widget',
  DISABLE_GOOGLE_TAG_MANAGER: 'disable-google-tag-manager',
  DISABLE_GRID_TAB_STATS: 'disable-grid-tab-stats',
  DISABLE_MARKET_GROUPS_API: 'disable-market-groups-api',
  DISABLE_OFFER_WIDGETS: 'disable-offer-widgets',
  DISABLE_SENTRY: 'disable-sentry',
  DISABLE_VWO: 'disable-vwo',
  ENABLE_LIVE_PRICES: 'enable-live-prices',
  RENDER_GTM_POST_HYDRATION: 'render-gtm-post-hydration',
  SUBS__PLUS__ALL_WNBA: 'subs__plus__all_wnba',
  SUBS__PLUS__HERO_PRICING: 'subs__plus__hero__pricing',
  SUBS__PLUS__INTERNAL_SEARCH_TOOLS: 'subs__plus__internal_search_tools',
  SUBS__PLUS__LAST_10_PERSISTENT_SORT: 'subs__plus__last_10_persistent_sort',
  SUBS__PLUS__LINE_REDUCTION: 'subs__plus__line_reduction',
  SUBS__PLUS__NEW_CATEGORY_GROUPS: 'subs__plus__new_category_groups',
  SUBS__PLUS__PADLOCKING: 'subs__plus__padlocking',
  SUBS__PLUS__Q4_PROPS: 'subs__plus__q4_props',
  SUBS__PLUS__SOCCER_BETTING_SPLITS: 'subs__plus__soccer_betting_splits',
  SUBS__PLUS__SOCCER_EPL_ONLY: 'subs__plus__soccer_epl_only',
  SUBS__PLUS__SOCCER_EV_TRENDS: 'subs__plus__soccer_ev_trends',
  SUBS__PLUS__SOCCER_TRENDS: 'subs__plus__soccer_trends',
  SUBS__PLUS__STATS_TABLE: 'subs__plus__stats_table',
  SUBS__PLUS__TEXT_SEARCH: 'subs__plus__text_search',
  SUBS__PLUS__TIPSTERS: 'subs__plus__tipsters',
  SUBS__PLUS__TRENDS__BARCHART: 'subs__plus__trends__barchart',
  SUBS__PLUS__WORLD_CUP26: 'subs__plus__world_cup26',
  RENDER_BEST_BETS_WIDGET_FULL_WIDTH: 'render-best-bets-widget-full-width',
  RENDER_ONBOARDING_AS_MYOC_LOGIN_CTA: 'render-onboarding-as-myoc-login-cta',
  RENDER_UK_HEADER_STYLE: 'render-uk-header-style',
};

/**
 * Request header that opts a single request into the UK header restyle at runtime (NGF-6475),
 * `oc-header-style: uk`. The analogue of the proxy's `oc-platform: astro` canary header
 * (apps/proxy/server.ts): it can be toggled per-request from a browser header-override extension or
 * curl — no env var, no server restart, no Unleash toggle flip. Unlike `oc-platform`, this header does
 * NOT affect proxy routing, so the proxy forwards it through untouched; it is read where the flag is
 * resolved (atlas's build-page-data loader, atlas-astro's evaluateFeatureFlags).
 */
export const UK_HEADER_STYLE_OVERRIDE_HEADER = 'oc-header-style';
const UK_HEADER_STYLE_OVERRIDE_VALUE = 'uk';

/**
 * Whether the incoming request opts into the UK header restyle via the `oc-header-style: uk` header.
 * Framework-agnostic — takes the raw header value so callers pass it from a web `Headers.get()`, a
 * Node `IncomingMessage.headers[...]`, etc. Mirrors the proxy's `isAstroPlatform` helper.
 */
export function isUkHeaderStyleForced(headerValue: string | null | undefined): boolean {
  return headerValue === UK_HEADER_STYLE_OVERRIDE_VALUE;
}

/**
 * Applies the per-request UK-header-style override to a single Unleash-resolved flag value, so the
 * override lives in ONE place for every app (atlas's loader, atlas-astro's evaluateFeatureFlags, …)
 * rather than being mirrored per orchestrator. Returns `true` for RENDER_UK_HEADER_STYLE when the
 * request carried `oc-header-style: uk` (compute `forceUkHeaderStyle` via {@link isUkHeaderStyleForced}
 * at the call site, where the request is in scope); otherwise the passed-in `enabled` is returned
 * unchanged — a no-op for every other flag and whenever the header is absent (i.e. always in normal
 * STG/PROD traffic), so it is safe to leave committed.
 */
export function resolveFlagWithLocalOverride(name: string, enabled: boolean, forceUkHeaderStyle = false): boolean {
  if (name === featureFlags.RENDER_UK_HEADER_STYLE && forceUkHeaderStyle) {
    return true;
  }
  return enabled;
}
